export const createAdminAction = (admin) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(admin);
      firestore
        .collection("admins")
        .doc(admin.userId)
        .set(admin)
        .then(() => {
          dispatch({
            type: "CREATE_ADMIN",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "CREATE_ADMIN_ERR",
            err
        });
    });
    };
  };
  